import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Quiz from "./component";
import {
  createAssessmentAttempt,
  getAssessmentAttempt,
  getBulkQuestions,
  getCareerContent,
  getUserAnswerByAssessmentAttemptId,
  getUserAnswerByAssessmentAttemptIdAndQuestionId,
  saveAssessmentResult,
  saveUserAnswer,
  updateAssessmentAttempt,
  updateUserAnswer,
} from "../quiz/actions";
import { getAssessmentResultByAssessmentAttemptId } from "../plan/actions";
import {
  GetUserById,
  isGuestOrPremiumUser,
  updateUser,
} from "../settings/actions";
import {
  createContentMap,
  getAssessmentByAssessmentId,
  getContentLatestVersion,
} from "../signup/actions";
import { getAssessment } from "../dashboard/actions";

const mapStateToProps = ({ funnelStep }) => ({
  funnelStep,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getBulkQuestionsConnect: getBulkQuestions,
      getAllAssessmentConnect: getAssessment,
      saveUserAnswerConnect: saveUserAnswer,
      updateUserAnswerConnect: updateUserAnswer,
      getUserAnswerByAssessmentAttemptIdAndQuestionIdConnect:
        getUserAnswerByAssessmentAttemptIdAndQuestionId,
      saveAssessmentResultConnect: saveAssessmentResult,
      getAssessmentAttemptConnect: getAssessmentAttempt,
      getAssessmentResultByAssessmentAttemptIdConnect:
        getAssessmentResultByAssessmentAttemptId,
      createAssessmentAttemptConnect: createAssessmentAttempt,
      updateAssessmentAttemptConnect: updateAssessmentAttempt,
      IsGuestOrPremiumUserConnect: isGuestOrPremiumUser,
      getContentLatestVersionConnect: getContentLatestVersion,
      getAssessmentByAssessmentIdConnect: getAssessmentByAssessmentId,
      createContentMapConnect: createContentMap,
      getUserAnswerByAssessmentAttemptIdConnect:
        getUserAnswerByAssessmentAttemptId,
      getCareerContent: getCareerContent,
      GetUserByIdConnect: GetUserById,
      UpdateUserConnect: updateUser,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Quiz);
